<template>
	<div class="banner-wrap" :class="{ 'banner-wrap-license': license }" :style="{ backgroundImage: 'url(' + dataUrl + ')' }">
		<div class="banner-details">
			<dl v-if="!license">
				<dt>Location</dt>
				<dd>{{location.Name}}</dd>
				<dt>License</dt>
				<dd>{{location.License.Name}}</dd>
				<dt>Phone Number</dt>
				<dd>{{location.Phone}}</dd>
				<dt>Email</dt>
				<dd v-html="FormatEmail(location.Email)"></dd>
			</dl>
			<dl v-else>
				<dt>License</dt>
				<dd>{{license.Name}}</dd>
				<template v-if="locations">
					<dt>Locations</dt>
					<dd v-for="(l, i) in locations" :key="i">{{l.Name}}</dd>
				</template>
			</dl>
		</div>
	</div>
</template>
<script>
	import { ref, inject, watch, computed, onMounted } from "vue";
	import { useRouter } from "vue-router";
	export default {
		props: {
			location: {
				type: Object,
				default: null
			},
			license: {
				type: Object,
				default: null
			},
			locations: {
				type: Array,
				default: null
			},
			placeholderColor: {
				type: String,
				default: "#da9f33",
			},
			width: {
				type: [Number, null],
				default: null
			},
			height: {
				type: [Number, null],
				default: null
			}
		},
		emits: ["click"],
		setup(props, context) {
			const $http = inject("$http");
			const $router = useRouter();

			const imgLoading = ref(true);
			const fetchedLocationLoading = ref(true);
			// const css = ref("");
			const fetchedLocation = ref(null);

			const GetLocation = async () => {
				fetchedLocationLoading.value = true;
				const request = `/api/v2/location/${props.license.PrimaryLocationID}`;
				try {
					const response = await $http.get(request);
					fetchedLocation.value = response.data;
					fetchedLocationLoading.value = false;
					PreloadImage();
				} catch (err) {
					console.error(err);
				}
				fetchedLocationLoading.value = false;
			};

			const dataUrl = computed(() => {
				if (!fetchedLocationLoading.value) {
					if (props.license) {
						return process.env.VUE_APP_API + "api/v2/cms/image/banner/" + fetchedLocation.value.UUID;
					} else {
						return process.env.VUE_APP_API + "api/v2/cms/image/banner/" + props.location.UUID;
					}
				} else {
					return "";
				}
			});

			const FormatEmail = (email) => {
				if (!email) return "";
				const parts = email.split("@");
				return parts[0] + "<wbr>@" + parts[1];
			};

			const PreloadImage = () => {
				const img = new Image();
				img.src = dataUrl.value;
				img.onload = () => {
					imgLoading.value = false;
				};
			}

			onMounted(() => {
				if (props.license) {
					GetLocation();
				} else {
					fetchedLocationLoading.value = false;
					PreloadImage();
				}
			});

			return {
				imgLoading,
				fetchedLocation,
				fetchedLocationLoading,
				dataUrl,
				FormatEmail
			};
		}
	};
</script>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.banner-wrap {
		display: block;
		position: relative;
		overflow: hidden;
		border-radius: $radius-small;
		width: 100%;
		height: 30rem;
		line-height: 0;
		
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;

		&.banner-wrap-license {
			height: 16rem;

			& > .banner-details {
				min-height: unset;
			}
		}

		// & > img {
		// 	height: 100%;
		// 	width: auto;
		// 	max-width: none;
		// 	border-radius: $radius-small;
		// }

		&::after {
				content: '';
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;

				width: 100%;
				height: 100%;

				background-color: rgba($boyden-blue-light, 0.1);
			}

		& > .banner-details {
			position: absolute;
			top: 0;
			left: $margin-body-large;
			z-index: 2;

			min-width: 18rem;
			min-height: 25rem;
			padding: $margin-element-huge;

			background-color: #1e2945E8;
			line-height: normal;
			color: #fff;

			& dt {
				font-size: pxUnits(14);
			}
			& dd {
				font-size: pxUnits(20);

				&:first-of-type {
					font-size: pxUnits(32);
				}
				&:not(:last-child) {
					margin-bottom: $margin-element-small;
				}
			}
		}
	}
</style>
